import PlanningOffer from "./PlanningOffer";

export default PlanningOffer;